//#region src/constants/carrier-options.ts
var e = {
	AbsentOnDelivery: "absent_on_delivery_note_platform_1",
	DpdNlTest: "DPD NL Test",
	PostNlPhysicalContract: "postnl_physical_contract",
	PostNlPackageSmallNl: "postnl_package_small_nl",
	DhlForYouCollectShipmentsContract: "dhl_for_you_collect_shipments_contract",
	DpdSmallPackageContract: "dpd_small_package_contract"
}, t = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, n = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
}, ee = [t.Dhl, t.Instabox], te = {
	[t.PostNl]: n.PostNl,
	[t.Bpost]: n.Bpost,
	[t.CheapCargo]: n.CheapCargo,
	[t.Dpd]: n.Dpd,
	[t.Instabox]: n.Instabox,
	[t.Dhl]: n.Dhl,
	[t.Bol]: n.Bol,
	[t.Ups]: n.Ups,
	[t.DhlForYou]: n.DhlForYou,
	[t.DhlParcelConnect]: n.DhlParcelConnect,
	[t.DhlEuroPlus]: n.DhlEuroPlus,
	[t.UpsStandard]: n.UpsStandard,
	[t.UpsExpressSaver]: n.UpsExpressSaver,
	[t.Gls]: n.Gls,
	[t.Brt]: n.Brt,
	[t.Trunkrs]: n.Trunkrs,
	[t.InPost]: n.InPost,
	[t.PosteItaliane]: n.PosteItaliane,
	[t.Spring]: n.Spring,
	[t.ViaTim]: n.ViaTim,
	[t.DhlFreight]: n.DhlFreight
}, ne = (e) => te[e], r = {
	[t.PostNl]: n.POSTNL,
	[t.Bpost]: n.BPOST,
	[t.CheapCargo]: n.CHEAP_CARGO,
	[t.Dpd]: n.DPD,
	[t.Instabox]: n.INSTABOX,
	[t.Dhl]: n.DHL,
	[t.Bol]: n.BOL,
	[t.Ups]: n.UPS,
	[t.DhlForYou]: n.DHL_FOR_YOU,
	[t.DhlParcelConnect]: n.DHL_PARCEL_CONNECT,
	[t.DhlEuroPlus]: n.DHL_EUROPLUS,
	[t.UpsStandard]: n.UPS_STANDARD,
	[t.UpsExpressSaver]: n.UPS_EXPRESS_SAVER,
	[t.Gls]: n.GLS,
	[t.Brt]: n.BRT,
	[t.Trunkrs]: n.TRUNKRS,
	[t.InPost]: n.INPOST,
	[t.PosteItaliane]: n.POSTE_ITALIANE,
	[t.Spring]: n.SPRING,
	[t.ViaTim]: n.VIA_TIM,
	[t.DhlFreight]: n.DHL_FREIGHT
}, re = (e) => r[e], ie = {
	[n.POSTNL]: t.PostNl,
	[n.BPOST]: t.Bpost,
	[n.CHEAP_CARGO]: t.CheapCargo,
	[n.DPD]: t.Dpd,
	[n.INSTABOX]: t.Instabox,
	[n.DHL]: t.Dhl,
	[n.BOL]: t.Bol,
	[n.UPS]: t.Ups,
	[n.DHL_FOR_YOU]: t.DhlForYou,
	[n.DHL_PARCEL_CONNECT]: t.DhlParcelConnect,
	[n.DHL_EUROPLUS]: t.DhlEuroPlus,
	[n.UPS_STANDARD]: t.UpsStandard,
	[n.UPS_EXPRESS_SAVER]: t.UpsExpressSaver,
	[n.GLS]: t.Gls,
	[n.BRT]: t.Brt,
	[n.TRUNKRS]: t.Trunkrs,
	[n.INPOST]: t.InPost,
	[n.POSTE_ITALIANE]: t.PosteItaliane,
	[n.SPRING]: t.Spring,
	[n.VIA_TIM]: t.ViaTim,
	[n.DHL_FREIGHT]: t.DhlFreight
}, ae = (e) => ie[e], oe = {
	[n.PostNl]: t.PostNl,
	[n.POSTNL]: t.PostNl,
	[n.Bpost]: t.Bpost,
	[n.BPOST]: t.Bpost,
	[n.CheapCargo]: t.CheapCargo,
	[n.CHEAP_CARGO]: t.CheapCargo,
	[n.Dpd]: t.Dpd,
	[n.DPD]: t.Dpd,
	[n.Instabox]: t.Instabox,
	[n.Dhl]: t.Dhl,
	[n.BolCom]: t.Bol,
	[n.Bol]: t.Bol,
	[n.BOL]: t.Bol,
	[n.Ups]: t.Ups,
	[n.DhlForYou]: t.DhlForYou,
	[n.DHL_FOR_YOU]: t.DhlForYou,
	[n.DhlParcelConnect]: t.DhlParcelConnect,
	[n.DHL_PARCEL_CONNECT]: t.DhlParcelConnect,
	[n.DhlEuroPlus]: t.DhlEuroPlus,
	[n.DHL_EUROPLUS]: t.DhlEuroPlus,
	[n.UpsStandard]: t.UpsStandard,
	[n.UPS_STANDARD]: t.UpsStandard,
	[n.UpsExpressSaver]: t.UpsExpressSaver,
	[n.UPS_EXPRESS_SAVER]: t.UpsExpressSaver,
	[n.Gls]: t.Gls,
	[n.GLS]: t.Gls,
	[n.Brt]: t.Brt,
	[n.BRT]: t.Brt,
	[n.Trunkrs]: t.Trunkrs,
	[n.TRUNKRS]: t.Trunkrs,
	[n.InPost]: t.InPost,
	[n.INPOST]: t.InPost,
	[n.PosteItaliane]: t.PosteItaliane,
	[n.POSTE_ITALIANE]: t.PosteItaliane,
	[n.Spring]: t.Spring,
	[n.SPRING]: t.Spring,
	[n.ViaTim]: t.ViaTim,
	[n.VIA_TIM]: t.ViaTim,
	[n.DhlFreight]: t.DhlFreight,
	[n.DHL_FREIGHT]: t.DhlFreight
}, se = (e) => oe[e], ce = {
	[t.PostNl]: "postnl",
	[t.Bpost]: "bpost",
	[t.CheapCargo]: "cheapCargo",
	[t.Dpd]: "dpd",
	[t.Instabox]: "instabox",
	[t.Dhl]: "dhl",
	[t.Bol]: "bol",
	[t.Ups]: "ups",
	[t.DhlForYou]: "dhlForYou",
	[t.DhlParcelConnect]: "dhlParcelConnect",
	[t.DhlEuroPlus]: "dhlEuroplus",
	[t.UpsStandard]: "upsStandard",
	[t.UpsExpressSaver]: "upsExpressSaver",
	[t.Gls]: "gls",
	[t.Brt]: "brt",
	[t.Trunkrs]: "trunkrs",
	[t.InPost]: "inPost",
	[t.PosteItaliane]: "posteItaliane",
	[t.Spring]: "spring",
	[t.ViaTim]: "viaTim",
	[t.DhlFreight]: "dhlFreight"
}, le = {
	Private: "PRIVATE",
	Business: "BUSINESS"
}, i = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
}, ue = [
	i.Austria,
	i.Belgium,
	i.Bulgaria,
	i.Croatia,
	i.Cyprus,
	i.CzechRepublic,
	i.Denmark,
	i.Estonia,
	i.Finland,
	i.France,
	i.Germany,
	i.Greece,
	i.Hungary,
	i.Ireland,
	i.Italy,
	i.Latvia,
	i.Lithuania,
	i.Luxembourg,
	i.Malta,
	i.Netherlands,
	i.Poland,
	i.Portugal,
	i.Romania,
	i.Slovakia,
	i.Slovenia,
	i.Spain,
	i.Sweden
], de = Object.values(i), fe = [
	i.Angola,
	i.AntiguaAndBarbuda,
	i.Aruba,
	i.Bahamas,
	i.Belize,
	i.Benin,
	i.Bermuda,
	i.BonaireSintEustatiusAndSaba,
	i.Botswana,
	i.BurkinaFaso,
	i.Burundi,
	i.Cameroon,
	i.CanaryIslands,
	i.CentralAfricanRepublic,
	i.Comoros,
	i.CongoBrazzaville,
	i.CongoKinshasa,
	i.CoteDIvoire,
	i.Curacao,
	i.Djibouti,
	i.Dominica,
	i.DutchAntilles,
	i.EquatorialGuinea,
	i.Eritrea,
	i.Fiji,
	i.Gabon,
	i.Gambia,
	i.Ghana,
	i.Grenada,
	i.Guyana,
	i.HongKong,
	i.Kiribati,
	i.KoreaPeoplesDemocraticRepublic,
	i.Macao,
	i.Malawi,
	i.Mali,
	i.Mauritania,
	i.Nauru,
	i.Qatar,
	i.Rwanda,
	i.SaintKittsAndNevis,
	i.SaoTomeAndPrincipe,
	i.Seychelles,
	i.SierraLeone,
	i.SintMaarten,
	i.Suriname,
	i.SyrianArabRepublic,
	i.TimorLeste,
	i.Togo,
	i.Tonga,
	i.Tuvalu,
	i.Uganda,
	i.UnitedArabEmirates,
	i.Vanuatu,
	i.Yemen,
	i.Zimbabwe
], pe = [
	i.Austria,
	i.Belgium,
	i.Bulgaria,
	i.Croatia,
	i.CzechRepublic,
	i.Estonia,
	i.Finland,
	i.France,
	i.Germany,
	i.Greece,
	i.Hungary,
	i.Ireland,
	i.Italy,
	i.Latvia,
	i.Lithuania,
	i.Luxembourg,
	i.Malta,
	i.Netherlands,
	i.Portugal,
	i.Romania,
	i.Slovakia,
	i.Slovenia,
	i.Spain,
	i.UnitedKingdom
], me = [
	i.Denmark,
	i.Germany,
	i.Sweden
], he = {
	LooseLoading: 1,
	Green: 2,
	White: 3,
	CheapCargo: 4
}, a = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, o = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, s = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
}, ge = {
	[a.EarlyMorning]: o.EarlyMorning,
	[a.Morning]: o.Morning,
	[a.Standard]: o.Standard,
	[a.Evening]: o.Evening,
	[a.Pickup]: o.Pickup,
	[a.PickupExpress]: o.PickupExpress,
	[a.SameDayDelivery]: o.SameDayDelivery,
	[a.Express]: o.Express
}, _e = (e) => ge[e], c = {
	[o.EarlyMorning]: a.EarlyMorning,
	[o.Morning]: a.Morning,
	[o.Standard]: a.Standard,
	[o.Evening]: a.Evening,
	[o.Pickup]: a.Pickup,
	[o.PickupExpress]: a.PickupExpress,
	[o.SameDayDelivery]: a.SameDayDelivery,
	[o.Express]: a.Express
}, ve = (e) => c[e], l = {
	[a.EarlyMorning]: s.EarlyMorning,
	[a.Morning]: s.Morning,
	[a.Standard]: s.Standard,
	[a.Evening]: s.Evening,
	[a.Pickup]: s.Pickup,
	[a.PickupExpress]: s.PickupExpress,
	[a.SameDayDelivery]: s.SameDayDelivery,
	[a.Express]: s.Express
}, ye = (e) => l[e], u = {
	[s.EarlyMorning]: o.EarlyMorning,
	[s.Morning]: o.Morning,
	[s.Standard]: o.Standard,
	[s.Evening]: o.Evening,
	[s.Pickup]: o.Pickup,
	[s.PickupExpress]: o.PickupExpress,
	[s.SameDayDelivery]: o.SameDayDelivery,
	[s.Express]: o.Express
}, be = (e) => u[e], d = {
	[a.EarlyMorning]: "earlyMorning",
	[a.Morning]: "morning",
	[a.Standard]: "standard",
	[a.Evening]: "evening",
	[a.Pickup]: "pickup",
	[a.PickupExpress]: "pickupExpress",
	[a.SameDayDelivery]: "sameDay",
	[a.Express]: "express"
}, xe = (e) => {
	if (e == null || e === "") return "";
	let t;
	if (typeof e == "number") t = e;
	else if (t = c[e], t == null) {
		let n = u[e];
		t = n == null ? void 0 : c[n];
	}
	return t != null && d[t] || String(e);
}, f = { Vasco: 1 }, Se = { Vasco: "vasco" }, Ce = { [f.Vasco]: Se.Vasco }, we = (e) => Ce[e], Te = {
	ACCOUNT_MAX_TOTAL_INVOICE_AMOUNT_REACHED: 1001,
	BOL_SHIP_ORDER_ITEMS_FAILED: 1002,
	BOL_AUTO_IMPORT_DISABLED: 1003,
	WEBHOOK_IMPORT_FAILED: 1004,
	BOL_SHIPMENT_STATUS_UPDATE_FAILED: 1005,
	ETSY_AUTO_IMPORT_DISABLED: 1006,
	ECWID_AUTO_IMPORT_DISABLED: 1007,
	AMAZON_AUTO_IMPORT_DISABLED: 1008,
	EXACT_AUTO_IMPORT_DISABLED: 1009,
	EXACT_DE_AUTO_IMPORT_DISABLED: 1010,
	WIX_AUTO_IMPORT_DISABLED: 1011,
	BLACKLISTED: 1012
}, Ee = {
	Apart: "apart",
	Nested: "nested",
	None: "none"
}, De = {
	Requested: "requested",
	Active: "active",
	Cancelled: "cancelled",
	Inactive: "inactive"
}, Oe = {
	New: 1,
	Active: 2,
	Inactive: 3,
	Suspended: 4,
	Unverified: 8,
	Anonymized: 9
}, ke = { InvalidCurrentPassword: 3425 }, Ae = {
	Mr: "mr",
	Ms: "ms"
}, je = {
	Recipient: "recipient",
	Collect: "collect"
}, Me = {
	Brackets: "brackets",
	Shipments: "shipments",
	ShipmentsWeekly: "shipments-weekly",
	ShipmentsT2: "shipments-t2",
	ShipmentsT3: "shipments-t3",
	ShipmentsT4: "shipments-t4",
	Returns: "returns",
	ReturnsWeekly: "returns-weekly",
	ReturnsT2: "returns-t2",
	ReturnsT3: "returns-t3",
	ReturnsT4: "returns-t4",
	Webshops: "webshops",
	WebshopsWeekly: "webshops-weekly",
	WebshopsT2: "webshops-t2",
	WebshopsT3: "webshops-t3",
	WebshopsT4: "webshops-t4",
	TransitTime: "transit-time",
	TransitTimeT2: "transit-time-t2",
	TransitTimeT3: "transit-time-t3",
	TransitTimeT4: "transit-time-t4",
	Surcharges: "surcharges",
	SurchargesT2: "surcharges-t2",
	SurchargesT3: "surcharges-t3",
	SurchargesT4: "surcharges-t4",
	Cases: "cases",
	CasesT2: "cases-t2",
	CasesT3: "cases-t3",
	CasesT4: "cases-t4",
	FinanceT2: "finance-t2",
	FinanceT3: "finance-t3",
	FinanceT4: "finance-t4",
	ShortcomingT2: "shortcoming-t2",
	ShortcomingT3: "shortcoming-t3",
	ShortcomingT4: "shortcoming-t4"
}, Ne = {
	Shipments: "shipments",
	Returns: "returns",
	Webshops: "webshops",
	TransitTime: "transit-time",
	Surcharges: "surcharges",
	Cases: "cases",
	Finance: "finance",
	Shortcoming: "shortcoming"
}, Pe = {
	Active: "active",
	Pending: "pending",
	Inactive: "inactive"
}, Fe = {
	Open: "open",
	Pending: "pending",
	Succes: "succes",
	Failure: "failure",
	Expired: "expired",
	Cancelled: "cancelled"
}, Ie = {
	Create: "create",
	Update: "update",
	Revoke: "revoke"
}, Le = {
	Discount: "Discount",
	Option: "Option",
	Refund: "Refund",
	Shipment: "Shipment",
	Surcharge: "Surcharge"
}, Re = {
	Prepaid: 1,
	Invoice: 2,
	DirectDebit: 3,
	PostPaymentDirectDebitPending: 4,
	PrePaymentDirectDebitPending: 5
}, ze = {
	Active: "active",
	Available: "available",
	Unavailable: "unavailable",
	Pending: "pending"
}, Be = {
	Monthly: "monthly",
	Weekly: "weekly"
}, Ve = {
	Emandate: "e_mandate",
	EmailForm: "email_form"
}, He = {
	ReverseCharge: "reverse_charge",
	General: "general",
	Zero: "zero"
}, Ue = 210, We = {
	Fulfilment: "Fulfilment NL PostNL",
	ParcelEu: "MyParcel Pakket EU PostNL",
	ParcelNl: "MyParcel Pakket NL PostNL",
	PackageSmallNl: "MyParcel Klein Pakket NL PostNL",
	PackageSmallBe: "MyParcel Klein Pakket BE PostNL",
	ParcelErs: "MyParcel Pakket ERS PostNL",
	MailboxParcel: "MyParcel Brievenbuspakje PostNL",
	SmpParcelEu: "België Pakket EU PostNL",
	SmpParceNL: "België Pakket NL PostNL",
	SmpParcelBe: "België Pakket BE PostNL",
	FlsParcelEu: "Flespakket Pakket EU PostNL",
	FlsParcelNl: "Flespakket Pakket NL PostNL",
	FlsParcelErs: "Flespakket Pakket ERS PostNL",
	FlsMailboxParcel: "Flespakket Brievenbuspakje PostNL"
}, Ge = {
	ParcelNl: "MyParcel Pakket NL DHL For You",
	ParcelBe: "MyParcel Pakket BE DHL For You",
	MailboxParcelNl: "MyParcel Brievenbuspakje NL DHL For You",
	MailboxParcelBe: "MyParcel Brievenbuspakje BE DHL For You",
	ParcelSameDayNl: "MyParcel Pakket NL DHL For You vandaag",
	MailboxParcelSameDayNl: "MyParcel Brievenbuspakje NL DHL For You vandaag",
	EnvelopeNl: "MyParcel Envelop NL DHL For You"
}, Ke = {
	ParcelNl: "MyParcel Pakket NL DHL Europlus",
	ParcelEu: "MyParcel Pakket EU DHL Europlus"
}, qe = { ParcelEu: "MyParcel Pakket EU DHL Parcel Connect" }, Je = {
	ParcelNl: "MyParcel Pakket NL DPD",
	ParcelEu: "MyParcel Pakket EU DPD",
	PackageSmallNl: "MyParcel Klein Pakket NL DPD",
	PackageSmallEu: "MyParcel Klein Pakket EU DPD",
	MailboxParcelNl: "MyParcel Brievenbuspakje NL DPD",
	SmpParcelEu: "België Pakket EU DPD",
	SmpParcelRow: "België Pakket ROW DPD",
	SmpParcelBe: "België Pakket BE DPD"
}, Ye = {
	ParcelBe: "België Pakket BE Bpost",
	ParcelEu: "België Pakket EU Bpost"
}, Xe = {
	ParcelNl: "MyParcel Pakket NL UPS Standaard",
	ParcelEu: "MyParcel Pakket EU UPS Standaard",
	ParcelNlExpressSaver: "MyParcel Pakket NL UPS Express Saver",
	ParcelEuExpressSaver: "MyParcel Pakket EU UPS Express Saver"
}, Ze = { ItalyParcelIt: "Italy Parcel IT BRT" }, Qe = { ItalyParcelIt: "Italy Parcel IT InPost" }, $e = { ItalyParcelIt: "Italy Parcel IT Poste Italiane" }, et = {
	Subscription: "MyParcel Abonnement zending",
	SmpSubscription: "België Abonnement zending"
}, tt = {
	Main: "main",
	Custom: "custom"
}, nt = {
	DemoReady: "demoReady",
	PortalLoaded: "portalLoaded",
	InitDemo: "initDemo",
	UpdateBranding: "updateBranding",
	UpdateFields: "updateFields",
	UpdateReturnSettings: "updateReturnSettings",
	Navigate: "navigate",
	MobileDisplayMode: "mobileDisplayMode",
	Locale: "locale"
}, rt = {
	Completed: "completed",
	Cancelled: "cancelled",
	Initialized: "initialized",
	Expired: "expired",
	InvalidHash: "invalid_hash"
}, it = {
	Registered: "registered",
	HandedToCarrier: "handed_to_carrier",
	Sorting: "sorting",
	Distribution: "distribution",
	Delivered: "delivered"
}, at = {
	Registered: 0,
	HandedToCarrier: 3,
	Sorting: 4,
	Distribution: 5,
	Delivered: 7
}, ot = {
	None: "none",
	InstagramPost: "instagram_post",
	TwitterTimeline: "twitter_timeline"
}, st = {
	Instagram: "instagram",
	Twitter: "twitter",
	Linkedin: "linkedin",
	Facebook: "facebook",
	Youtube: "youtube",
	Tiktok: "tiktok"
}, ct = {
	Euro: "EUR",
	Usd: "USD"
}, p = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, m = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
}, lt = {
	[m.Sunday]: p.Sunday,
	[m.Monday]: p.Monday,
	[m.Tuesday]: p.Tuesday,
	[m.Wednesday]: p.Wednesday,
	[m.Thursday]: p.Thursday,
	[m.Friday]: p.Friday,
	[m.Saturday]: p.Saturday
}, ut = {
	[p.Sunday]: m.Sunday,
	[p.Monday]: m.Monday,
	[p.Tuesday]: m.Tuesday,
	[p.Wednesday]: m.Wednesday,
	[p.Thursday]: m.Thursday,
	[p.Friday]: m.Friday,
	[p.Saturday]: m.Saturday
}, dt = (e) => ut[e], ft = (e) => lt[e], pt = {
	Affiliate: 1,
	Return: 2,
	Tracktrace: 3,
	ShipmentLabel: 4,
	TracktraceReturn: 5
}, mt = {
	CSV: "text/csv",
	TXT: "text/plain",
	PDF: "application/pdf"
}, h = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
}, ht = [
	h.Bytes,
	h.Kilobytes,
	h.Megabytes,
	h.Gigabytes,
	h.Terabytes
], gt = {
	Automatic: "automatic",
	Manual: "manual"
}, _t = {
	Invalid: 3415,
	Dimensions: 3440,
	Filetype: 3441,
	Width: 3442,
	Size: 3462
}, vt = {
	Shipments: "shipments",
	ShipmentsWeekly: "shipments-weekly",
	ShipmentsT2: "shipments-t2",
	ShipmentsT3: "shipments-t3",
	Returns: "returns",
	ReturnsWeekly: "returns-weekly",
	ReturnsT2: "returns-t2",
	ReturnsT3: "returns-t3",
	Webshops: "webshops",
	WebshopsWeekly: "webshops-weekly",
	WebshopsT2: "webshops-t2",
	WebshopsT3: "webshops-t3",
	TransitTime: "transit-time",
	TransitTimeT2: "transit-time-t2",
	TransitTimeT3: "transit-time-t3",
	Surcharges: "surcharges",
	SurchargesT2: "surcharges-t2",
	SurchargesT3: "surcharges-t3",
	Cases: "cases",
	CasesT2: "cases-t2",
	CasesT3: "cases-t3",
	FinanceT2: "finance-t2",
	FinanceT3: "finance-t3",
	ShortcomingT2: "shortcoming-t2",
	ShortcomingT3: "shortcoming-t3"
}, yt = {
	Shipments: "shipments",
	Returns: "returns",
	Webshops: "webshops",
	TransitTime: "transit-time",
	Surcharges: "surcharges",
	Cases: "cases",
	Finance: "finance",
	Shortcoming: "shortcoming"
}, g = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, _ = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
}, v = {
	[g.Bol]: _.Bol,
	[g.Exact]: _.Exact,
	[g.Amazon]: _.Amazon,
	[g.Wix]: _.Wix,
	[g.ExactDe]: _.ExactDe,
	[g.Etsy]: _.Etsy
}, bt = (e) => v[e], y = {
	[_.Bol]: g.Bol,
	[_.Exact]: g.Exact,
	[_.Amazon]: g.Amazon,
	[_.Wix]: g.Wix,
	[_.ExactDe]: g.ExactDe,
	[_.Etsy]: g.Etsy
}, xt = (e) => y[e], St = {
	Pending: 1,
	Active: 2,
	Blocked: 3
}, Ct = {
	Reminder1: "billing_invoice_first_reminder",
	Reminder2: "billing_invoice_second_reminder",
	Dun: "billing_invoice_due_dun"
}, b = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, x = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
}, wt = {
	[b.Unpaid]: x.Unpaid,
	[b.Due]: x.Due,
	[b.DuePrepayment]: x.DuePrepayment,
	[b.Reminder1]: x.Reminder1,
	[b.Reminder2]: x.Reminder2,
	[b.Dun]: x.Dun,
	[b.Collection]: x.Collection,
	[b.Instalments]: x.Instalments,
	[b.PaymentArrangement]: x.PaymentArrangement,
	[b.Dispute]: x.Dispute,
	[b.LegalProcedure]: x.LegalProcedure,
	[b.Insolvency]: x.Insolvency,
	[b.WriteOff]: x.WriteOff,
	[b.Pending]: x.Pending,
	[b.Cancelled]: x.Cancelled,
	[b.Paid]: x.Paid,
	[b.PaidOnline]: x.PaidOnline,
	[b.PaidAutomatic]: x.PaidAutomatic,
	[b.PaidCredit]: x.PaidCredit,
	[b.PaidZeroItems]: x.PaidZeroItems,
	[b.InvoiceWith0InvoiceItemsPaidZeroBalance]: x.PaidZeroBalance
}, Tt = [
	b.Due,
	b.Reminder1,
	b.Reminder2,
	b.Dun,
	b.Collection,
	b.Instalments,
	b.PaymentArrangement,
	b.Dispute
], Et = [
	b.Paid,
	b.PaidOnline,
	b.PaidAutomatic,
	b.PaidCredit,
	b.PaidZeroItems
], Dt = {
	Open: "open",
	Paid: "paid"
}, Ot = {
	Customer: 1,
	Consumer: 2,
	ConsumerERS: 3
}, kt = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, At = {
	Full: "full",
	Half: "half"
}, jt = { Toaster: "toaster" }, Mt = {
	Asc: "ASC",
	Desc: "DESC"
}, Nt = {
	MyParcel: "myparcel",
	User: "user"
}, Pt = {
	Gram: "gram",
	Kilogram: "kilogram"
}, S = {
	Gram: "g",
	Kilogram: "kg"
}, Ft = {
	[S.Gram]: 1,
	[S.Kilogram]: 1e3
}, It = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, C = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, Lt = {
	[C.Millimeter]: .1,
	[C.Centimeter]: 1,
	[C.Meter]: 100
}, Rt = {
	Dm3Refund1: "Dm3 Refund 0-55",
	Dm3Refund2: "Dm3 Refund 55-105",
	Dm3Refund3: "Dm3 Refund 105-205",
	Dm3Refund4: "Dm3 Refund 205",
	Dm3Surcharge1: "Dm3 Surcharge 0-55",
	Dm3Surcharge2: "Dm3 Surcharge 55-105",
	Dm3Surcharge3: "Dm3 Surcharge 105-205",
	Dm3Surcharge4: "Dm3 Surcharge 205",
	ErsAt: "ERS Shipment AT",
	ErsBe: "ERS Shipment BE",
	ErsBg: "ERS Shipment BG",
	ErsCz: "ERS Shipment CZ",
	ErsDe: "ERS Shipment DE",
	ErsEe: "ERS Shipment EE",
	ErsEs: "ERS Shipment ES",
	ErsFi: "ERS Shipment FI",
	ErsFr: "ERS Shipment FR",
	ErsGb: "ERS Shipment GB",
	ErsGr: "ERS Shipment GR",
	ErsHr: "ERS Shipment HR",
	ErsHu: "ERS Shipment HU",
	ErsIe: "ERS Shipment IE",
	ErsIt: "ERS Shipment IT",
	ErsLt: "ERS Shipment LT",
	ErsLu: "ERS Shipment LU",
	ErsLv: "ERS Shipment LV",
	ErsMt: "ERS Shipment MT",
	ErsPt: "ERS Shipment PT",
	ErsRo: "ERS Shipment RO",
	ErsSi: "ERS Shipment SI",
	ErsSk: "ERS Shipment SK",
	InsurancePostNl: "Insurance PostNL",
	InsurancePostNlEur100: "Insurance PostNL EUR 100",
	InsurancePostNlEur250: "Insurance PostNL EUR 250",
	InsurancePostNlEur50ToEuRow: "Insurance PostNL EUR 50 to EU & ROW",
	InsurancePostNlEur500PlusNlToBe: "Insurance PostNL EUR 500 Plus NL to BE",
	InsurancePostNlEur500ToEuRow: "Insurance PostNL EUR 500 to EU & ROW",
	InsurancePostNlEur500: "Insurance PostNL EUR 500",
	InsurancePostNlNlToBeEur500: "Insurance PostNL NL to BE EUR 500",
	LargeFormatNl: "Large Format NL",
	LargeFormatEu: "Large Format EU",
	LargeFormatBe: "Large Format BE",
	LargeFormatDe: "Large Format DE",
	LargeFormatFr: "Large Format FR",
	LargeFormatEs: "Large Format ES",
	LargeFormatRefundNl: "Large Format Refund NL",
	LargeFormatRefundEu: "Large Format Refund EU",
	LargeFormatRefundBe: "Large Format Refund BE",
	LargeFormatRefundDe: "Large Format Refund DE",
	LargeFormatRefundFr: "Large Format Refund FR",
	LargeFormatRefundEs: "Large Format Refund ES",
	LargeFormatSurchargeNl: "Large Format Surcharge NL",
	LargeFormatSurchargeEu: "Large Format Surcharge EU",
	LargeFormatSurchargeBe: "Large Format Surcharge BE",
	LargeFormatSurchargeDe: "Large Format Surcharge DE",
	LargeFormatSurchargeFr: "Large Format Surcharge FR",
	LargeFormatSurchargeEs: "Large Format Surcharge ES",
	ShipmentAu: "Shipment AU",
	ShipmentBe: "Shipment BE",
	ShipmentBr: "Shipment BR",
	ShipmentCa: "Shipment CA",
	ShipmentCh: "Shipment CH",
	ShipmentCn: "Shipment CN",
	ShipmentEu3: "Shipment EU3",
	ShipmentGb: "Shipment GB",
	ShipmentHk: "Shipment HK",
	ShipmentJp: "Shipment JP",
	ShipmentNl: "Shipment NL",
	ShipmentNo: "Shipment NO",
	ShipmentNz: "Shipment NZ",
	ShipmentRow: "Shipment ROW",
	ShipmentUs: "Shipment US",
	ShipmentZa: "Shipment ZA",
	ShipmentEu1And2: "Shipment EU 1 & 2",
	ShipmentEs: "Shipment ES",
	ShipmentDe: "Shipment DE",
	ShipmentFr: "Shipment FR",
	ShipmentItStandardHomeToHome: "Shipment Italy Standard Home to Home",
	ShipmentItExpressHomeToHome: "Shipment Italy Express Home to Home",
	ShipmentItStandardShopToHome: "Shipment Italy Standard Shop to Home",
	ShipmentItStandardHomeToPostOffice: "Shipment Italy Standard Home to Post Office",
	ShipmentItExpressHomeToPostOffice: "Shipment Italy Express Home to Post Office",
	ShipmentItStandardShopToPostOffice: "Shipment Italy Standard Shop to Post Office",
	ShipmentItStandardShopToPuntoPoste: "Shipment Italy Standard Shop to Punto Poste",
	ShipmentItStandardHomeToPuntoPoste: "Shipment Italy Standard Home to Punto Poste",
	ShipmentItExpressHomeToPuntoPoste: "Shipment Italy Express Home to Punto Poste",
	WeightAu: "Weight AU",
	WeightBr: "Weight BR",
	WeightCa: "Weight CA",
	WeightCh: "Weight CH",
	WeightCn: "Weight CN",
	WeightEu3: "Weight EU3",
	WeightGb: "Weight GB",
	WeightHk: "Weight HK",
	WeightJp: "Weight JP",
	WeightNo: "Weight NO",
	WeightNz: "Weight NZ",
	WeightRow: "Weight ROW",
	WeightUs: "Weight US",
	WeightZa: "Weight ZA",
	AgeCheck: "age_check",
	Signature: "Signature",
	OnlyRecipient: "Only recipient",
	OnlyRecipientSignature: "Only recipient & Signature",
	PrinterlessReturn: "Printerless return",
	BundleMaxLabelFee: "Bundle Max label fee",
	BundleMaxLabelDiscount: "Bundle Max label discount",
	BundleMaxShipmentDiscount: "Bundle Max shipment discount",
	BundlePlusLabelDiscount: "Bundle Plus label discount",
	BundlePlusLabelFee: "Bundle Plus label fee",
	BundlePlusShipmentDiscount: "Bundle Plus shipment discount",
	BundlePremiumLabelDiscount: "Bundle Premium label discount",
	BundlePremiumLabelFee: "Bundle Premium label fee",
	BundlePremiumShipmentDiscount: "Bundle Premium shipment discount",
	BundleStartLabelDiscount: "Bundle Start label discount",
	BundleStartLabelFee: "Bundle Start label fee",
	BundleStartShipmentDiscount: "Bundle Start shipment discount",
	Brievenbuspakje: "Brievenbuspakje",
	BrievenbuspakjePeakSurcharge: "Brievenbuspakje Peak Surcharge",
	BrievenbuspakjeToeslag: "Brievenbuspakje Toeslag",
	DigitalePostzegel: "Digitale postzegel",
	SmallParcelEU: "Small Parcel EU",
	SmallParcelROW: "Small Parcel ROW",
	MailboxPackageEU: "Mailbox Package EU",
	MailboxPackageROW: "Mailbox Package ROW",
	EnergySurcharge: "Energy surcharge",
	EveningDelivery: "Evening delivery",
	IncorrectConfirmation: "Incorrect Confirmation",
	KortingOphaallocatie: "Korting ophaallocatie",
	ManualProcessing: "Manual Processing",
	ManualProcessingNoContract: "Manual Processing (no contract)",
	ManualProcessingNoContractRefund: "Manual Processing (no contract) refund",
	ManualProcessingRefund: "Manual Processing refund",
	MaximumDimensionsExceeded: "Maximum Dimensions Exceeded",
	MorningDelivery: "Morning delivery",
	MulticolloDiscount: "Multicollo discount",
	NotificationSurcharge: "Notification Surcharge",
	PeakSurcharge: "Peak Surcharge",
	PromotionalDiscount: "Promotional discount",
	UndeliverableEuShipment: "Undeliverable EU Shipment",
	UndeliverableRowShipment: "Undeliverable ROW Shipment",
	WeightSurcharge: "Weight Surcharge",
	WeightSurchargeRefund: "Weight Surcharge refund",
	DhlSurcharge10To24Dm3To10Kg: "DHL surcharge 10-24 dm3 / to 10 kg",
	DhlSurcharge24To60Dm3To15Kg: "DHL surcharge 24-60 dm3 / to 15 kg",
	DhlSurcharge60To240Dm3To23Kg: "DHL surcharge 60-240 dm3 / to 23 kg",
	DhlSurcharge240To432Dm3To315Kg: "DHL surcharge 240-432 dm3 / to 31.5 kg",
	DhlForYouPakketNlS: "DHL For You Pakket NL - S",
	DhlForYouPakketNlM: "DHL For You Pakket NL - M",
	DhlForYouPakketNlL: "DHL For You Pakket NL - L",
	DhlForYouPakketNlXl: "DHL For You Pakket NL - XL",
	DhlForYouPakketNlXxl: "DHL For You Pakket NL - XXL",
	DhlForYouPakketBeS: "DHL For You Pakket BE - S",
	DhlForYouPakketBeM: "DHL For You Pakket BE - M",
	DhlForYouPakketBeL: "DHL For You Pakket BE - L",
	DhlForYouPakketBeXl: "DHL For You Pakket BE - XL",
	DhlForYouPakketBeXxl: "DHL For You Pakket BE - XXL",
	DhlEveningDelivery: "DHL Evening delivery",
	DhlSaturdayDelivery: "DHL Saturday delivery",
	DhlSignatureOnDelivery: "DHL Signature on delivery",
	DhlNotAtNeighbours: "DHL Not at neighbours",
	DhlAgeCheck: "DHL Age check",
	DhlExtraAssurance: "DHL Extra assurance",
	DhlForYouLetterboxParcelNetherlands: "DHL For You Letterbox Parcel Netherlands",
	DhlTodayParcel: "DHL Today (parcel)",
	DhlTodayLetterbox: "DHL Today (letterbox)",
	ImplicitDiscount: "Implicit discount",
	DhlForYouLetterboxParcelBelgium: "DHL For You Letterbox Parcel Belgium",
	DhlSamedayParcel: "DHL Sameday Parcel",
	DhlSamedayLetterboxParcel: "DHL Sameday Letterbox parcel",
	DhlFuelSurcharge: "DHL Fuel surcharge",
	DhlTollSurcharge: "DHL Toll surcharge",
	DhlGoGreenSurcharge: "DHL GoGreen surcharge",
	DhlParcelConnectParcel: "DHL Parcel Connect parcel",
	DhlExtraLarge: "DHL Extra large",
	DhlHeavyParcel: "DHL Heavy parcel",
	DhlEuroplusParcel: "DHL Europlus parcel",
	DhlEuroplusParcelNl: "DHL Europlus parcel NL",
	UpsStandardPackage: "UPS Standard Package",
	UpsExpressSaverPackage: "UPS Express Saver Package",
	UpsStandardPackageShipmentPickup: "UPS Standard Package + Shipment pickup",
	UpsExpressSaverPackageShipmentPickup: "UPS Express Saver Package + Shipment pickup",
	UpsProfitMargin: "UPS Profit margin",
	StandardPackageBe: "Standard package BE",
	StandardPackageFromPickupLocationBe: "Standard package from pickup location BE",
	ShipmentEuBe: "Shipment EU BE",
	RowBe: "ROW BE",
	StandardMailboxBe: "Standard Mailbox BE",
	HomeDeliveryBe: "Home delivery BE",
	HomeDeliveryEu: "Home delivery EU",
	PickupBe: "Pickup BE",
	PickupEu: "Pickup EU",
	PickupReturnBe: "Pickup Return BE",
	PickupReturnEu: "Pickup Return EU",
	HomeDeliveryRow: "Home delivery ROW"
}, w = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, zt = {
	Amazon: "AMAZON",
	Bol: "BOL",
	Etsy: "ETSY",
	Exact: "EXACT",
	Cscart: "CSCART",
	Lightspeed: "LIGHTSPEED",
	Magento: "MAGENTO",
	Presta: "PRESTA",
	Shopify: "SHOPIFY",
	Wix: "WIX",
	Woocommerce: "WOOCOMMERCE"
}, Bt = {
	Delivered: "delivered",
	Dispatching: "dispatching",
	Distributing: "distributing",
	PickingAndPacking: "pickingAndPacking",
	Sorting: "sorting",
	Untraceable: "untraceable"
}, T = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
}, Vt = [T.PendingConcept], Ht = [T.PendingRegistered], Ut = [
	T.EnRouteHandedToCarrier,
	T.EnRouteSorting,
	T.EnRouteDistribution,
	T.EnRouteCustoms
], Wt = [T.DeliveredReadyForPickup], Gt = [T.DeliveredAtRecipient, T.DeliveredPackagePickedUp], Kt = {
	Standard: 1,
	Return: 2,
	MultiColli: 3,
	LabelPackage: 4,
	ReturnErs: 5,
	UpsExpress: 7
}, qt = {
	Pending: "pending",
	Unpaid: "unpaid",
	Paid: "paid"
}, Jt = {
	AgeCheck: "age_check",
	Collect: "collect",
	Contribution: "contribution",
	CooledDelivery: "cooled_delivery",
	DeliveryDate: "delivery_date",
	DeliveryType: "delivery_type",
	DropOffAtPostalPoint: "drop_off_at_postal_point",
	ExtraAssurance: "extra_assurance",
	FreshFood: "fresh_food",
	Frozen: "frozen",
	HideSender: "hide_sender",
	Insurance: "insurance",
	LabelDescription: "label_description",
	LargeFormat: "large_format",
	OnlyRecipient: "only_recipient",
	PackageType: "package_type",
	PrinterlessReturn: "printerless_return",
	PriorityDelivery: "priority_delivery",
	ReceiptCode: "receipt_code",
	Return: "return",
	SameDayDelivery: "same_day_delivery",
	SaturdayDelivery: "saturday_delivery",
	Signature: "signature",
	Tracked: "tracked"
}, Yt = {
	CommercialGoods: 1,
	CommercialSamples: 2,
	Documents: 3,
	Gifts: 4,
	ReturnShipment: 5
}, Xt = {
	Standard: "standard",
	Return: "return"
}, E = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, D = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
}, Zt = {
	Zero: 0,
	One: 1,
	Two: 2,
	Three: 3,
	Four: 4,
	Five: 5
}, Qt = {
	[D.Light]: E.Light,
	[D.Start]: E.Start,
	[D.Plus]: E.Plus,
	[D.Premium]: E.Premium,
	[D.Max]: E.Max
}, $t = {
	[E.Light]: D.Light,
	[E.Start]: D.Start,
	[E.Plus]: D.Plus,
	[E.Premium]: D.Premium,
	[E.Max]: D.Max
}, en = (e) => Qt[e], tn = (e) => $t[e], O = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, k = {
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, nn = {
	[O.Start]: k.Start,
	[O.Plus]: k.Plus,
	[O.Premium]: k.Premium,
	[O.Max]: k.Max
}, rn = {
	[k.Start]: O.Start,
	[k.Plus]: O.Plus,
	[k.Premium]: O.Premium,
	[k.Max]: O.Max
}, an = (e) => nn[e], on = (e) => rn[e], sn = {
	AllowCustomContracts: "allow_custom_contracts",
	AllowBolDotComVvbShipments: "allow_bol_dot_com_vvb_shipments",
	AllowAutoOrderImport: "allow_auto_order_import",
	AllowOrderNotes: "allow_order_notes",
	AllowUnlimitedShipmentsPerOrderLine: "allow_unlimited_shipments_per_order_line",
	AllowOrderInvoice: "allow_order_invoice",
	AllowOrderPicklist: "allow_order_picklist",
	AllowNestedShipmentLabelOnPackingSlip: "allow_nested_shipment_label_on_packing_slip",
	AllowShopLogoOnPackingSlip: "allow_shop_logo_on_packing_slip",
	ExtendedShippingRules: "extended_shipping_rules",
	UnlimitedShippingRules: "unlimited_shipping_rules",
	AllowTier1Analytics: "allow_tier1_analytics",
	AllowTier2Analytics: "allow_tier2_analytics",
	AllowTier3Analytics: "allow_tier3_analytics",
	ShipmentDiscount: "shipment_discount"
}, A = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, j = {
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, M = {
	[A.Start]: j.Start,
	[A.Plus]: j.Plus,
	[A.Premium]: j.Premium,
	[A.Max]: j.Max
}, N = {
	[j.Start]: A.Start,
	[j.Plus]: A.Plus,
	[j.Premium]: A.Premium,
	[j.Max]: A.Max
}, cn = (e) => M[e], ln = (e) => N[e], P = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, F = {
	Light: E.Light,
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, I = {
	[P.Light]: F.Light,
	[P.Start]: F.Start,
	[P.Plus]: F.Plus,
	[P.Premium]: F.Premium,
	[P.Max]: F.Max
}, L = {
	[F.Light]: P.Light,
	[F.Start]: P.Start,
	[F.Plus]: P.Plus,
	[F.Premium]: P.Premium,
	[F.Max]: P.Max
}, un = (e) => I[e], dn = (e) => L[e], R = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, z = {
	Start: E.Start,
	Plus: E.Plus,
	Premium: E.Premium,
	Max: E.Max
}, B = {
	[R.Start]: z.Start,
	[R.Plus]: z.Plus,
	[R.Premium]: z.Premium,
	[R.Max]: z.Max
}, V = {
	[z.Start]: R.Start,
	[z.Plus]: R.Plus,
	[z.Premium]: R.Premium,
	[z.Max]: R.Max
}, fn = (e) => B[e], pn = (e) => V[e], mn = {
	MyContract: "my_contracts",
	MyAnalytics: "my_analytics",
	MyOrders: "my_orders",
	MyScanAndPrint: "my_scan_and_print",
	MyReturns: "my_returns",
	Bundle: "bundle"
}, hn = {
	Active: "active",
	Ended: "ended",
	Pending: "pending",
	StartingSoon: "starting_soon",
	EndingSoon: "ending_soon",
	TrialActive: "trial_active",
	TrialEnded: "trial_ended"
}, gn = {
	Open: "open",
	Closed: "closed"
}, _n = {
	Damage: "damage",
	InvoiceChangeDetails: "invoice_change_details",
	InvoiceOtherQuestion: "invoice_other_question",
	MissingContent: "missing_content",
	MyReturnsCancellation: "my_returns_cancellation",
	MyReturnsRequest: "my_returns_request",
	NoValueChosen: "no_value_chosen",
	NotDelivered: "not_delivered",
	NotReceivedRecipient: "not_received_recipient",
	NotReceivedRecipientBbp: "not_received_recipient_bbp",
	OtherSystemQuestion: "other_system_question",
	Packaging: "packaging",
	PalletShipmentQuestion: "pallet_shipment_question",
	PluginHelpNeeded: "plugin_help_needed",
	PluginQuestion: "plugin_question",
	Products: "products",
	Rates: "rates",
	RecipientIncorrect: "recipient_incorrect",
	Return: "return",
	ShipmentExportHelpNeeded: "shipment_export_help_needed",
	ShipmentOtherQuestion: "shipment_other_question",
	WebshopOrders: "webshop_orders"
}, vn = {
	MyShipments: 1,
	System: 2,
	ProductsAndPrices: 3,
	MyInvoice: 4,
	Different: 5,
	MyCollectTrip: 6,
	Fulfilment: 7,
	MyReturns: 8
}, yn = {
	NL: "nl",
	EN: "en",
	FR: "fr",
	IT: "it",
	ES: "es",
	DE: "de"
}, bn = {
	Text: "Text",
	ChangeStatus: "ChangeStatus",
	EmailMessage: "EmailMessage"
}, xn = {
	SHIPMENT_FORM: 1,
	DASHBOARD: 2,
	GLOBAL_MESSAGE: 3,
	COLLECTION_TRIP_MESSAGE: 4,
	CASES_OVERVIEW: 5,
	CONTACT: 6
}, Sn = {
	ALERT: "alert",
	WARNING: "warning",
	SUCCESS: "success",
	INFO: "info",
	DEFAULT: "info"
}, Cn = {
	Ok: 1,
	Processing: 2,
	Failed: 3,
	Cancelled: 4,
	Expired: 5,
	Declined: 6,
	PartialRefunded: 7,
	ChargedBack: 8,
	Refunded: 9,
	Reserved: 10,
	Uncleared: 11,
	InvalidHash: 12
}, wn = {
	BankTransfer: 1,
	Ideal: 2,
	DirectDebit: 4,
	SystemCorrection: 5,
	CollectionAgency: 6,
	OtherManualPayment: 7
}, Tn = {
	Owner: "customer_main",
	Main: "customer_admin",
	Regular: "customer_sub",
	Warehouse: "customer_warehouse",
	Marketing: "customer_marketing",
	CustomerService: "customer_service",
	Financial: "customer_financial",
	FunctionalManager: "customer_functional_manager",
	Sales: "sales",
	ItSupport: "it_support",
	Finance: "finance",
	CsAdvanced: "cs_advanced",
	Cs: "cs",
	SuperAdmin: "super_admin"
}, En = { MissingRoutingNumberOrPecEmail: 3474 }, Dn = {
	ShipmentLabelCreated: "shipment_label_created",
	ShipmentStatusChange: "shipment_status_change"
}, H = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, U = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, W = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
}, On = {
	[H.MyParcel]: U.MyParcel,
	[H.Flespakket]: U.Flespakket,
	[H.SendMyParcel]: U.SendMyParcel,
	[H.MyParcelIt]: U.MyParcelIt,
	[H.DeliverDutch]: U.DeliverDutch,
	[H.PostNlPlugin]: U.PostNlPlugin
}, kn = (e) => On[e], An = {
	[H.MyParcel]: W.MyParcelNl,
	[H.Flespakket]: W.MyParcelNl,
	[H.SendMyParcel]: W.MyParcelBe,
	[H.MyParcelIt]: W.MyParcelIt,
	[H.DeliverDutch]: W.DeliverDutch,
	[H.PostNlPlugin]: W.PostNlPlugin
}, jn = (e) => An[e], Mn = {
	[W.MyParcelNl]: H.MyParcel,
	[W.MyParcelBe]: H.SendMyParcel,
	[W.MyParcelIt]: H.MyParcelIt
}, Nn = {
	[W.MyParcelNl]: {
		[w.HomeCountry]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[i.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[w.Eu]: [
			0,
			5e3,
			5e4
		],
		[w.Row]: [
			0,
			5e3,
			5e4
		],
		[i.Belgium]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		]
	},
	[W.MyParcelBe]: {
		[w.HomeCountry]: [0, 5e4],
		[i.Belgium]: [0, 5e4],
		[i.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[w.Eu]: [
			0,
			5e3,
			5e4
		],
		[w.Row]: [
			0,
			5e3,
			5e4
		]
	}
}, Pn = { [W.MyParcelBe]: {
	[w.HomeCountry]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[i.Belgium]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[w.Eu]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[w.Row]: [
		0,
		5e4,
		25e4,
		5e5
	]
} }, G = { [W.MyParcelNl]: {
	[w.HomeCountry]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[i.Netherlands]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[w.Eu]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[w.Row]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, K = { [W.MyParcelNl]: {
	[w.HomeCountry]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[i.Netherlands]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[i.Belgium]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[i.Luxembourg]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, Fn = {
	[t.Bpost]: Pn,
	[t.PostNl]: Nn,
	[t.DhlForYou]: G,
	[t.DhlParcelConnect]: G,
	[t.DhlEuroPlus]: G,
	[t.Ups]: K,
	[t.UpsStandard]: K,
	[t.UpsExpressSaver]: K
}, In = {
	a4: "A4",
	a6: "A6"
}, Ln = {
	topLeft: "2",
	topRight: "4",
	bottomLeft: "1",
	bottomRight: "3"
}, q = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, J = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
}, Y = {
	[q.Package]: J.Package,
	[q.Mailbox]: J.Mailbox,
	[q.Letter]: J.Letter,
	[q.DigitalStamp]: J.DigitalStamp,
	[q.Pallet]: J.Pallet,
	[q.PackageSmall]: J.PackageSmall,
	[q.Envelope]: J.Envelope
}, Rn = (e) => Y[e], X = {
	[J.Package]: q.Package,
	[J.Mailbox]: q.Mailbox,
	[J.Letter]: q.Letter,
	[J.DigitalStamp]: q.DigitalStamp,
	[J.Pallet]: q.Pallet,
	[J.PackageSmall]: q.PackageSmall,
	[J.Envelope]: q.Envelope
}, zn = (e) => X[e], Z = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
}, Bn = {
	[q.Package]: Z.PACKAGE,
	[q.Mailbox]: Z.MAILBOX,
	[q.Letter]: Z.UNFRANKED,
	[q.DigitalStamp]: Z.DIGITAL_STAMP,
	[q.Pallet]: Z.PALLET,
	[q.PackageSmall]: Z.SMALL_PACKAGE,
	[q.Envelope]: Z.ENVELOPE
}, Vn = (e) => Bn[e], Q = {
	[Z.PACKAGE]: q.Package,
	[Z.MAILBOX]: q.Mailbox,
	[Z.UNFRANKED]: q.Letter,
	[Z.DIGITAL_STAMP]: q.DigitalStamp,
	[Z.PALLET]: q.Pallet,
	[Z.SMALL_PACKAGE]: q.PackageSmall,
	[Z.ENVELOPE]: q.Envelope
}, Hn = (e) => Q[e], Un = {
	[q.Package]: "package",
	[q.Mailbox]: "mailbox",
	[q.Letter]: "letter",
	[q.DigitalStamp]: "digitalStamp",
	[q.Pallet]: "pallet",
	[q.PackageSmall]: "packageSmall",
	[q.Envelope]: "envelope"
}, Wn = (e) => {
	if (e == null || e === "") return "";
	let t = typeof e == "number" ? e : X[e] ?? Q[e];
	return t != null && Un[t] || String(e);
}, $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
}, Gn = [$.PendingConcept, $.PendingRegistered], Kn = [
	$.EnrouteHandedToCarrier,
	$.EnrouteSorting,
	$.EnrouteDistribution,
	$.DeliveredAtCustoms
], qn = [
	$.DeliveredAtRecipient,
	$.DeliveredPackagePickedUp,
	$.DeliveredReturnShipmentPackagePickedUp,
	$.DeliveredAtAgreedLocation
], Jn = [$.PrintedLetter, $.PrintedDigitalStamp], Yn = [
	$.InactiveConcept,
	$.InactiveRegistered,
	$.InactiveEnrouteHandedToCarrier,
	$.InactiveEnrouteSorting,
	$.InactiveEnrouteDistribution,
	$.InactiveEnrouteCustoms,
	$.InactiveDeliveredAtRecipient,
	$.InactiveDeliveredReadyForPickup,
	$.InactiveDeliveredPackagePickedUp
], Xn = {
	Passed: "passed",
	Failed: "failed",
	Error: "error",
	Pending: "pending"
}, Zn = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, Qn = {
	GRAM: "g",
	KILOGRAM: "kg"
};
//#endregion
//#region src/type-guards/isEvent.ts
function $n(e) {
	return e instanceof Event;
}
//#endregion
//#region src/type-guards/isHtmlElement.ts
function er(e) {
	return e instanceof HTMLElement;
}
//#endregion
//#region src/type-guards/isCarrier.ts
var tr = (e) => Object.values(n).includes(e), nr = (e) => Object.values(t).includes(e);
//#endregion
export { de as ALL_COUNTRIES, ke as AccountError, Te as AccountMessageSpecifics, Oe as AccountStatus, je as AddressType, Ne as AnalyticsDashboardCategory, Me as AnalyticsDashboardSlug, nn as BUNDLES_IDS_TO_NAMES, rn as BUNDLES_NAMES_TO_IDS, Be as BillingCycle, Re as BillingMethodId, ze as BillingStatus, He as BillingVatType, Ye as BpostBracketName, Pn as BpostInsuranceAmounts, Ze as BrtBracketName, O as BundlesProductId, k as BundlesTierName, fe as COUNTRIES_WITHOUT_POSTAL_CODE, t as CarrierId, te as CarrierIdToName, r as CarrierIdToNameV2, ce as CarrierIdToTranslationKey, n as CarrierName, oe as CarrierNameToId, ie as CarrierNameV2ToId, e as CarrierOptionsLabel, Vt as ConceptShipmentStatusIds, W as ConfigKey, Mn as ConfigKeyToPlatformId, le as ContactType, tt as ContractType, i as Country, he as CourierProductId, ct as Currency, Yt as CustomsDeclarationContents, ut as DAYS_OF_WEEK_IDS_TO_NAMES, lt as DAYS_OF_WEEK_NAMES_TO_IDS, p as DaysOfWeek, m as DaysOfWeekName, Gt as DeliveredShipmentStatusIds, a as DeliveryTypeId, ge as DeliveryTypeIdToName, l as DeliveryTypeIdToNameV2, d as DeliveryTypeIdToTranslationKey, o as DeliveryTypeName, c as DeliveryTypeNameToId, s as DeliveryTypeNameV2, u as DeliveryTypeNameV2ToName, Ke as DhlEuroplusBracketName, Ge as DhlForYouBracketName, G as DhlInsuranceAmounts, qe as DhlParcelConnectBracketName, C as Dimension, Lt as DimensionFactor, It as DimensionName, Ve as DirectDebitType, ee as DiscontinuedCarriers, Je as DpdBracketName, pe as ERS_COUNTRIES, ue as EU_COUNTRIES, zt as EcommerceSalesChannels, pt as EmailTemplateType, Ut as EnRouteShipmentStatusIds, g as ExternalProviderId, v as ExternalProviderIdToName, _ as ExternalProviderName, y as ExternalProviderNameToId, h as FileSizeUnits, mt as FileType, gt as FulfilmentMode, f as FulfilmentPartnerId, Ce as FulfilmentPartnerIdToName, Se as FulfilmentPartnerName, Ae as Gender, _t as ImageError, Wt as InPickupLocationShipmentStatusIds, Qe as InPostBracketName, yt as InsightsDashboardCategory, vt as InsightsDashboardSlug, Fn as InsuranceAmounts, St as InvitationStatus, Tt as InvoiceOpenStatus, Et as InvoicePaidStatus, Ct as InvoiceReminderName, b as InvoiceStatus, wt as InvoiceStatusIdToNameMap, x as InvoiceStatusName, Dt as InvoiceTab, Ot as InvoiceType, Yn as LegacyShipmentStatuses, Zn as LengthUnit, M as MY_ANALYTICS_IDS_TO_NAMES, N as MY_ANALYTICS_NAMES_TO_IDS, I as MY_CONTRACTS_IDS_TO_NAMES, L as MY_CONTRACTS_NAMES_TO_IDS, B as MY_ORDERS_IDS_TO_NAMES, V as MY_ORDERS_NAMES_TO_IDS, Pe as MandateStatus, Fe as MandateTransactionStatus, Ie as MandateTransactionType, Qn as MassUnit, A as MyAnalyticsProductId, j as MyAnalyticsTierName, P as MyContractsProductId, F as MyContractsTierName, R as MyOrdersProductId, z as MyOrdersTierName, De as MyReturnsStatus, jt as NotificationLocation, At as NotificationSize, kt as NotificationVariant, me as PUDO_COUNTRIES, q as PackageTypeId, Y as PackageTypeIdToName, Bn as PackageTypeIdToNameV2, Un as PackageTypeIdToTranslationKey, J as PackageTypeName, X as PackageTypeNameToId, Q as PackageTypeNameV2ToId, In as PaperSize, Nt as PayingParty, rt as PaymentStatusName, H as PlatformId, On as PlatformIdToName, U as PlatformName, nt as PortalEvents, We as PostNlBracketName, Nn as PostNlInsuranceAmounts, $e as PosteItalianeBracketName, Ln as PrintLabelPosition, Rt as ProductName, Le as ProductType, w as Region, Ht as RegisteredShipmentStatusIds, Tn as RoleType, Ee as ShipmentLabel, Jt as ShipmentOptionName, Z as ShipmentPackageTypeV2, $ as ShipmentStatus, qn as ShipmentStatusDelivered, Kn as ShipmentStatusEnroute, Bt as ShipmentStatusGroups, T as ShipmentStatusId, at as ShipmentStatusNumber, Gn as ShipmentStatusPending, Jn as ShipmentStatusPrinted, qt as ShipmentTransactionStatus, Kt as ShipmentTypeId, Xt as ShippingRuleType, st as SocialPlatforms, ot as SocialWidgetType, Mt as SortOrder, _n as SubType, sn as SubscriptionFeature, et as SubscriptionName, hn as SubscriptionStatus, Qt as SubscriptionTierIdToName, $t as SubscriptionTierNameToId, mn as SubscriptionType, bn as SupportCaseInteractionType, gn as SupportCaseStatus, vn as SupportCaseType, yn as SupportLanguages, xn as SystemMessageType, Sn as SystemNotificationType, D as TierId, E as TierName, Zt as TierRange, it as TrackTraceShipmentStatus, Cn as TransactionStatus, wn as TransactionType, Xe as UpsBracketName, K as UpsInsuranceAmounts, En as VettingError, Xn as VettingStatus, Dn as WebhookType, S as Weight, Ft as WeightFactor, Pt as WeightName, en as convertTierIdToName, tn as convertTierNameToId, ht as fileSizeUnits, be as fromDeliveryTypeNameV2, nr as isCarrierId, tr as isCarrierName, $n as isEvent, er as isHtmlElement, on as toBundlesProductId, an as toBundlesTierName, se as toCarrierId, ae as toCarrierIdV2, ne as toCarrierName, re as toCarrierNameV2, jn as toConfigKey, ft as toDayOfWeekId, dt as toDayOfWeekName, ve as toDeliveryTypeId, _e as toDeliveryTypeName, ye as toDeliveryTypeNameV2, xe as toDeliveryTypeTranslationKey, xt as toExternalProviderId, bt as toExternalProviderName, we as toFulfilmentPartnerName, ln as toMyAnalyticsProductId, cn as toMyAnalyticsTierName, un as toMyContractsTierName, pn as toMyOrdersProductId, fn as toMyOrdersTierName, zn as toPackageTypeId, Hn as toPackageTypeIdFromNameV2, Rn as toPackageTypeName, Vn as toPackageTypeNameV2, Wn as toPackageTypeTranslationKey, kn as toPlatformName, dn as toSubscriptionProductId, Ue as vatTariffPercentage };

//# sourceMappingURL=index.js.map